import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";

const LINKS = [
  { label: "Trips", href: "/trips" },
  { label: "Roamies IRL", href: "/irl" },
  { label: "How It Works", href: "/#how-it-works" },
  { label: "About", href: "/#about" },
  { label: "FAQ", href: "/faq" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 backdrop-blur-xl text-cream border-b transition-all duration-300 ${
        scrolled ? "bg-ink/90 border-white/10 shadow-[0_8px_30px_rgba(0,0,0,0.35)]" : "bg-ink/75 border-white/5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo"
          className="font-display text-2xl tracking-tight text-cream"
        >
          ROAMIES<span className="text-flame">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-xs font-bold uppercase tracking-[0.18em] text-cream/70 hover:text-flame transition-colors"
            >
              {l.label}
            </a>
          ))}
          <Button
            asChild
            data-testid="nav-join-drop-btn"
            className="bg-flame hover:bg-flame/90 text-white rounded-none font-bold uppercase tracking-widest text-xs px-6 transition-transform hover:scale-[1.03]"
          >
            <a href="/#waitlist">Join the Next Drop</a>
          </Button>
        </nav>

        <div className="md:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button data-testid="mobile-menu-btn" aria-label="Open menu" className="p-2 text-cream">
                <Menu className="w-6 h-6" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-ink text-cream border-ink w-72">
              <div className="flex flex-col gap-6 mt-10">
                {LINKS.map((l) => (
                  <a
                    key={l.label}
                    href={l.href}
                    onClick={() => setOpen(false)}
                    data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="font-display text-3xl uppercase tracking-tight hover:text-flame transition-colors"
                  >
                    {l.label}
                  </a>
                ))}
                <Button
                  asChild
                  data-testid="mobile-nav-join-drop-btn"
                  className="bg-flame hover:bg-flame/90 text-white rounded-none font-bold uppercase tracking-widest mt-4"
                >
                  <a href="/#waitlist" onClick={() => setOpen(false)}>Join the Next Drop</a>
                </Button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
